import { useMemo } from 'react';
import { EqualityFn } from 'react-redux';

import { useAppDispatch, useAppSelector, store as appStore } from '@STORE/index';
import { deleteSectionModalSlice, DeleteSectionModalDispatchParams, DeleteSectionModalState } from '@REDUCERS';

function createDeleteSectionModalHook() {
    return function useDeleteSectionModal(equalityFn?: EqualityFn<DeleteSectionModalState>) {
        const modalState = useAppSelector((store) => store.deleteSectionModal, equalityFn);

        const dispatch = useAppDispatch();

        const actions = useMemo(() => ({
            open: (params: DeleteSectionModalDispatchParams, onSuccess?: () => void) => {
                dispatch(deleteSectionModalSlice.actions.open(params));
                const unsubscribe = appStore.subscribe(() => {
                    const currentState = appStore.getState().deleteSectionModal;
                    if (currentState.confirmed) {
                        if (onSuccess) {
                            onSuccess();
                        }
                        unsubscribe();
                    }
                });
            },
            close: () => dispatch(deleteSectionModalSlice.actions.close()),
            confirm: () => {
                dispatch(deleteSectionModalSlice.actions.confirm());
            },
        }), [dispatch]);

        return {
            state: modalState,
            actions,
        };
    };
}

export default createDeleteSectionModalHook();
